<div class="mui-footer__links">
  <ng-container *ngFor="let link of links">
    <a *ngIf="link.context === appContext"
       [id]="link.id"
       [translate]="link.labelI18nKey"
       [routerLink]="link.basePath + link.url"
       class="mui-footer__link internal"
       data-qa="footer-link-internal"
    ></a>
    <a *ngIf="link.context !== appContext"
       [id]="link.id"
       [translate]="link.labelI18nKey"
       [href]="link.basePath + link.url"
       class="mui-footer__link external"
       data-qa="footer-link-external"
    ></a>
  </ng-container>
</div>
